import DOMPurify from 'dompurify';

import { Button } from 'components/FormComponents';

export const ConsentsList = ({ consents, consentsTitle, consentsDescription }) => {
  return (
    <div className="d-flex flex-column">
      <div className="flex flex-row gap-2 justify-between items-center p-8 border-b border-border-primary bg-neutral-1 rounded-t-2xl">
        <div className="flex flex-col gap-2">
          {consentsTitle && (
            <div className="text-neutral-7 text-3xl font-semibold">{consentsTitle}</div>
          )}
          {consentsDescription && (
            <div className="text-neutral-6 text-xl font-regular">{consentsDescription}</div>
          )}
        </div>
      </div>
      <div className="p-8">
        {consents?.length > 0 &&
          (consents || [])?.map((consent, index) => (
            <div
              key={consent.id ?? `consent-${index}`}
              className="flex flex-col gap-2 bg-neutral-1 p-4 border border-neutral-4 rounded-2xl">
              <div className="flex justify-between items-center">
                <span className="primary-text u-font-weight-500 u-font-size-small">
                  {consent.title}
                </span>
                {consent.upload?.url && (
                  <Button
                    type="secondary"
                    icon="download"
                    onClick={() =>
                      window.open(consent.upload.url, '_blank', 'noopener,noreferrer')
                    }>
                    Download report
                  </Button>
                )}
              </div>
              {consent.content && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(consent.content, {
                      ALLOWED_TAGS: ['div', 'span', 'p', 'ul', 'ol', 'li', 'strong', 'em', 'br'],
                      ALLOWED_ATTR: [],
                    }),
                  }}
                />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};
